import { Heading, Stack } from "@chakra-ui/react";
import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";

export default function WorldDomination() {
  return (
    <Stack gap={10} height="full" fill="#2982CC">
      <Heading fontSize={{ base: "18px", md: "24px" }} fontWeight={"semibold"}>
        World Domination 0%
      </Heading>
      <ComposableMap>
        <Geographies geography="/features.json">
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography key={geo.rsmKey} geography={geo} />
            ))
          }
        </Geographies>
        <Marker coordinates={[-70.006, 190.7128]}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22.997"
            height="33.079"
            viewBox="0 0 22.997 33.079"
          >
            <path
              id="placeholder"
              d="M5.248,0A11.511,11.511,0,0,0-6.25,11.5c0,7.969,11.51,21.581,11.51,21.581s11.487-14,11.487-21.581A11.511,11.511,0,0,0,5.248,0ZM8.718,14.865a4.906,4.906,0,1,1,0-6.938A4.891,4.891,0,0,1,8.718,14.865Zm0,0"
              transform="translate(6.25)"
              fill="#fff700"
            />
          </svg>
        </Marker>
      </ComposableMap>
    </Stack>
  );
}
